import React from "react"

import alabamaLegislature from "./alabama-legislature.webp"
import alabamaAdminCode from "./alabama-admin-code.webp"
import birthInDueSeason from "./birth-in-due-season.webp"
import naturalPrenatals from "./natural-prenatals.webp"
import kingdomPowerElectricalServices from "./kingdom-power-electrical-services.webp"
import seasonOfHope from "./season-of-hope.webp"
import turnTimer from "./turn-timer.webp"
import countdowns from "./countdowns.webp"
import ferreiraLife from "./ferreira-life.webp"

const works: [image: string, title: string, url: string][] = [
	[alabamaLegislature, "Alabama Legislature", "https://beta.alaleg.gov"],
	[
		alabamaAdminCode,
		"Alabama Administrative Code",
		"https://admincode.legislature.state.al.us"
	],
	[birthInDueSeason, "Birth In Due Season", "https://birthindueseason.org"],
	[naturalPrenatals, "Natural Mama Supplements", "https://naturalprenatals.com"],
	[
		kingdomPowerElectricalServices,
		"Kingdom Power Electrical Services",
		"https://kpes.pro"
	],
	[seasonOfHope, "Season of Hope", "https://season4hope.org"],
	[ferreiraLife, "Ferreira.Life", "https://ferreira.life"],
	[turnTimer, "Turn Timer", "https://timer.ericmakesapps.com"],
	[countdowns, "Countdowns", "https://countdowns.ericmakesapps.com"]
]

export const Work: React.FC = () => {
	return (
		<div className="w-content">
			<h2 className="text-3xl mb-5">Our work</h2>
			<ul className="grid grid-cols-2 lg:grid-cols-4 gap-4">
				{works.map(([image, title, url]) => (
					<li key={url} className="flex items-center justify-center">
						<a
							href={url}
							className="text-xl block w-full text-center text-balance"
							target="_blank"
							rel="noreferrer noopener"
						>
							<img src={image} alt="" className="w-full max-h-96 object-contain" />
							{title}
						</a>
					</li>
				))}
			</ul>
		</div>
	)
}
